<template>
  <div>
    <!-- Opciones de manejo de clientes -->
    <div class="d-flex text-left mt-3 mb-3">
      <label class="mr-2">¿Cómo deseas proceder?</label>
      <select v-model="operationType" class="form-control w-auto" @change="handleClientHandlingChange">
        <option value="overwrite">Sobrescribir Lista</option>
        <option value="add">Añadir DNIs a la lista existente</option>
      </select>
    </div>

    <!-- Mensaje de éxito -->
    <div v-if="successMessage" class="alert alert-success mt-3">
      {{ successMessage }}
    </div>

    <!-- Mensaje de error -->
    <div v-if="errorMessage" class="alert alert-danger mt-3">
      {{ errorMessage }}
    </div>

    <!-- Zona de arrastrar y soltar -->
    <div class="dropClients">
      <div
          class="dropClients-dropzone-container"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="drop"
      >
        <input
            type="file"
            name="file"
            id="fileInput"
            class="dropClients-dropzone-container-hidden-input"
            @change="onChange"
            ref="file"
            accept=".csv,.xlsx"
        />
        <label for="fileInput" class="dropClients-dropzone-container-file-label">
          <div v-if="isDragging">Suelta para insertar archivo</div>
          <div v-else>Arrastra el archivo aquí o <u>haz clic aquí</u> para añadir.</div>
        </label>
      </div>
    </div>

    <!-- Previsualización de archivos -->
    <div
        class="d-flex justify-content-center dropClients-dropzone-container-preview-container mt-4"
        v-if="files.length"
    >
      <div
          v-for="file in files"
          :key="file.name"
          class="dropClients-dropzone-container-preview-container-preview-card"
      >
        <div class="position-relative">
          <button type="button" class="close" @click="remove" aria-label="Delete">
            <span aria-hidden="true">&times;</span>
          </button>
          <p class="fileName">{{ file.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    promotionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isDragging: false,
      files: [],
      operationType: "overwrite", // Opción por defecto
      successMessage: "",
      errorMessage: "",
    };
  },
  watch: {
    promotionId: {
      immediate: true,
      handler() {
        this.resetState(); // Reinicia el estado cuando cambia la promoción
      },
    },
  },
  methods: {
    resetState() {
      this.files = [];
      this.operationType = "overwrite"; // Restablece la opción a su valor por defecto
      this.successMessage = "";
      this.errorMessage = "";
      if (this.$refs.file) {
        this.$refs.file.value = ""; // Limpia el input de archivo
      }
    },
    handleClientHandlingChange() {
      // Emitir la opción seleccionada al componente padre
      this.$emit("clientHandlingChanged", this.operationType);
    },
    async onChange() {
      this.files = [...this.$refs.file.files];
      if (this.files.length > 1) {
        this.errorMessage = "Solo puedes subir un archivo a la vez.";
        this.files = [];
        this.clearMessages();
        return;
      }

      try {
        const file = this.files[0];
        await this.processFile(file);
        this.successMessage = `Archivo "${file.name}" cargado correctamente.`;
      } catch (error) {
        this.errorMessage = error.message || "Error al procesar el archivo. Por favor, inténtalo nuevamente.";
      } finally {
        this.clearMessages();
      }
    },
    async processFile(file) {
      const reader = new FileReader();
      const vm = this;

      return new Promise((resolve, reject) => {
        reader.onload = async (e) => {
          try {
            const binaryData = e.target.result;
            const bodyToSend = { csv: window.btoa(binaryData) };

            const response = await axios.post("/promotions/validate/custumer-csv", bodyToSend);
            const formattedList = response.data.split(",");

            if (vm.operationType === "add") {
              // Combinar con la lista actual
              const currentList = await vm.fetchCurrentClientList();
              vm.$emit("clientList", [...currentList, ...formattedList]);
            } else {
              // Sobrescribir la lista completa
              vm.$emit("clientList", formattedList);
            }

            resolve();
          } catch (error) {
            reject(new Error("Archivo inválido o error al procesarlo."));
          }
        };
        reader.readAsBinaryString(file);
      });
    },
    async fetchCurrentClientList() {
      try {
        const response = await axios.get(`/promotions/promotion/${this.promotionId}`);
        return response.data.customers?.legal_identifier || [];
      } catch (error) {
        console.error("Error al recuperar la lista de clientes actual:", error);
        return [];
      }
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.isDragging = false;

      if (e.dataTransfer.files.length > 1) {
        this.errorMessage = "Solo puedes subir un archivo a la vez.";
        this.clearMessages();
        return;
      }

      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
    },
    remove() {
      this.resetState();
      this.$emit("clientList", []); // Emitir lista vacía al padre
    },
    clearMessages() {
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, 3000); // Oculta los mensajes después de 3 segundos
    },
  },
};
</script>

<style lang="scss" scoped>
.dropClients {
  display: flex;
  flex-grow: 1;
  align-items: center;
  &-dropzone-container {
    padding: 4rem;
    width: 45rem;
    max-height: 220px;
    background: #f7fafc;
    border: 1px solid #e2e8f0;
    &-hidden-input {
      display: none;
    }
    &-file-label {
      font-size: 20px;
      cursor: pointer;
    }
    &-preview-container {
      display: flex;
      margin-top: 2rem;
      &-preview-card {
        padding: 5px;
        margin-left: 5px;
        .close {
          font-size: 1.5rem;
          position: absolute;
          top: 0;
          right: -12px;
        }
        .fileName {
          max-width: 150px;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
